export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="py-10 md:py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-7 h-7 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-sm"></i>
              </div>
              <span className="font-heading text-base font-bold text-background-50">
                久播影院
              </span>
            </div>
            <p className="text-xs md:text-sm text-background-400 leading-relaxed">
              高清免费在线观影平台。每日更新，流畅播放，影院级画质。好电影，不等待。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-background-100 mb-3">快速导航</h4>
            <div className="space-y-2">
              <a href="#hero" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</a>
              <a href="#carousel" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">精选推荐</a>
              <a href="#index" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">影片分类</a>
              <a href="#ranking" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">本周热播</a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-background-100 mb-3">热门分类</h4>
            <div className="space-y-2">
              <span className="block text-xs md:text-sm text-background-400">动作片</span>
              <span className="block text-xs md:text-sm text-background-400">科幻片</span>
              <span className="block text-xs md:text-sm text-background-400">悬疑片</span>
              <span className="block text-xs md:text-sm text-background-400">动画片</span>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-background-100 mb-3">合作伙伴</h4>
            <p className="text-xs md:text-sm text-background-400 leading-relaxed">
              我们期待与更多优质内容方和平台建立合作，共同为影迷带来更好的观影体验。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700/50 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 久播影院 jiubomovie.com —— 高清电影免费在线观看平台
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">关于我们</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">联系方式</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}